import { EventEmitter, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Header } from '../models/enum';
import { LocalizationService } from './localization.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public visible = false;
  public openDrawer = new EventEmitter();
  public closeDrawer = new EventEmitter();
  public drawerOpenedEvent = new EventEmitter();
  public drawerClosedEvent = new EventEmitter();
  public drawerFinishedOpeningEvent = new EventEmitter();
  public title: string;
  public titleChanged = new EventEmitter();
  public drawerClosed = true;
  public menuTriggerVisible = false;
  public menuTriggerVisibleEvent = new EventEmitter();
  public nomeAlbergoVisibleEvent = new EventEmitter();
  public header = Header.Sbm;
  public elencoVisibleEvent = new EventEmitter();
  public titleVisibleElenco: boolean = false;
  public onElencoClick: () => void;

  constructor(private titleService: Title, private localizationService: LocalizationService) { }

  setTitle(title: string, setHeader: boolean = true) {
    if (setHeader) {
      this.titleChanged.emit(title);
    }

    this.titleService.setTitle('Extranet - ' + this.localizationService.getTranslationSync(title));
    this.title = title;
  }

  clearTitle() {
    this.titleChanged.emit('');
    this.titleService.setTitle('Welcome');
    this.title = null;
  }

  showHeader(header?: Header) {
    setTimeout(() => {
      this.visible = true;
    }, 200);

    if (header != null) {
      this.header = header;
    }
  }

  hideHeader() {
    this.visible = false;
  }

  setDrawerOpened() {
    this.drawerClosed = false;
    this.drawerOpenedEvent.emit();
  }

  setDrawerClosed() {
    this.drawerClosed = true;
    this.drawerClosedEvent.emit();
  }

  setHeader(header: Header) {
    this.header = header;
  }

  showMenuTrigger() {
    this.menuTriggerVisible = true;
    this.menuTriggerVisibleEvent.emit(true);
  }

  hideMenuTrigger() {
    this.menuTriggerVisible = false;
    this.menuTriggerVisibleEvent.emit(false);
  }

  showNomeAlbergo() {
    this.nomeAlbergoVisibleEvent.emit(true);
  }

  hideNomeAlbergo() {
    this.nomeAlbergoVisibleEvent.emit(false);
  }

  showElenco(onElencoClick: () => void, showTitle: boolean = false, name?: string) {
    this.titleVisibleElenco = showTitle;

    let elencoName = !!name ? name : this.title;

    if (!!elencoName) {
      let elencoLabel = this.localizationService.getTranslationSync('globals.elenco', { value: this.localizationService.getTranslationSync(elencoName) });
      this.elencoVisibleEvent.emit(elencoLabel[0].toUpperCase() + elencoLabel.substring(1).toLowerCase());
    } else {
      this.elencoVisibleEvent.emit(null);
    }

    this.onElencoClick = onElencoClick;
  }

  hideElenco() {
    this.elencoVisibleEvent.emit(null);
    this.onElencoClick = null;
  }
}